import styles from '../_signup.module.scss'
import Image from 'next/legacy/image'
import artistImg from '@public/images/artist.png'
import PendingInvitationContent from '../../../components/modals/PendingInvitationContent'

interface PendingInvitationProps {
  email: string
  invitationOrganization?: string
  onSignUpAnyway: () => void
}

const PendingInvitation: React.FC<PendingInvitationProps> = ({
  email,
  invitationOrganization,
  onSignUpAnyway
}) => {
  return (
    <div>
      <div className={styles.signupForm}>
        <PendingInvitationContent
          email={email}
          invitationOrganization={invitationOrganization}
          onSecondaryAction={onSignUpAnyway}
          buttonStyles={{
            primaryButton: styles.button,
            secondaryButton: styles.secondaryButton
          }}
        />
      </div>
      <div className={styles.signupPicture}>
        <Image alt="Artist" src={artistImg} height={535} width={696} />
      </div>
    </div>
  )
}

export default PendingInvitation
